import FilterListIcon from '@mui/icons-material/FilterList';
import { Badge } from '@mui/material';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useFilterAppliedLength } from '../../../hooks';
import { reportFilterCountryCodeSelector } from '../../../state';
import { DialogFiltersProps, useReportFilters } from '../ReportFiltersProvider';
import FiltersDialogSelector from './FiltersDialogSelector';

const FilterDialogWrapper = () => {
  const { t } = useTranslation();
  const hasCountry = Boolean(useSelector(reportFilterCountryCodeSelector));
  const { loadingSelector, dialogFiltersConfig } = useReportFilters();
  const { options, filters, selector } = dialogFiltersConfig as DialogFiltersProps;
  const badgeContent = useFilterAppliedLength(options || [], selector);
  const disabled = useSelector(loadingSelector) || !hasCountry;

  const [open, setOpen] = useState(false);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleClick = useCallback(() => setOpen(true), []);
  const handleClickApply = useCallback(() => {
    handleClose();
  }, [handleClose]);
  return (
    <>
      <Tooltip title={t('toolbar.labels.filter') as string}>
        <Badge badgeContent={badgeContent} color="primary">
          <Button color="primary" variant="contained" onClick={handleClick} disabled={disabled}>
            <FilterListIcon />
          </Button>
        </Badge>
      </Tooltip>
      {open && (
        <FiltersDialogSelector onApply={handleClickApply} onClose={handleClose}>
          {filters}
        </FiltersDialogSelector>
      )}
    </>
  );
};

const FilterDialog = () => {
  const { dialogFiltersConfig } = useReportFilters();

  return dialogFiltersConfig ? <FilterDialogWrapper /> : null;
};

export default FilterDialog;
